// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"8456":"d4a59ef1","9730":"40247457"}[chunkId] || chunkId) + "." + {"7835":"2bb150337ddcf2f6","8456":"ba7d158803938c26","9730":"2c8646e8626f28d5","9796":"52d7e3d546a155b9"}[chunkId] + ".js";
};